import { HTMLAttributes } from 'react';
import { cn } from '@/utils/cn';
import { Button } from '@/components/common/Button/Button';

interface CTAProps extends HTMLAttributes<HTMLDivElement> {
  title: string;
  description: string;
  cta: {
    text: string;
    href: string;
    secondary?: {
      text: string;
      href: string;
    };
  };
}

export const CTA = ({
  title,
  description,
  cta,
  className,
  ...props
}: CTAProps) => {
  return (
    <section
      className={cn(
        'py-24 relative overflow-hidden bg-black',
        className
      )}
      {...props}
    >
      {/* Background pattern */}
      <div className="absolute inset-0 w-full h-full bg-black">
        {/* Grid pattern */}
        <div
          className="absolute inset-0 w-full h-full"
          style={{
            backgroundImage: 'url(https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/Home+page-+Images/Background+Pattern.svg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            opacity: 1,
          }}
        />
        {/* Light effect overlay */}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_-20%,rgba(255,255,255,0.2),transparent_60%)]" />
        {/* Additional subtle top glow */}
        <div className="absolute top-0 left-0 right-0 h-[300px] bg-gradient-to-b from-white/5 to-transparent" />
      </div>

      <div className="container mx-auto px-4 relative">
        <div className="max-w-2xl mx-auto text-center text-white">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">{title}</h2>
          <p className="text-lg md:text-xl text-white/80 mb-8">{description}</p>
          <div className="flex flex-row items-center justify-center gap-4 mb-12 md:mb-16">
            <Button
              variant="solid"
              color="primary"
              size="lg"
              onClick={() => {
                window.open(cta.href, '_blank');
              }}
            >
              {cta.text}
            </Button>
            {cta.secondary && (
              <Button
                variant="gradient"
                color="primary"
                size="lg"
                onClick={() => {
                  if (cta.secondary) {
                    window.open(cta.secondary.href, '_blank');
                  }
                }}
              >
                {cta.secondary.text}
              </Button>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};